import {selector} from "./selector";
import * as helper from "../../app/helper";

function showFormErrors(errors) {
    for (let prop in errors) {
        if (prop === 'order_number')
            $(selector.errorMessage).html(errors[prop]);
        else
            $('#' + prop).addClass('is-invalid').next().html(errors[prop]).show();
    }
}

const submitForm = (e) => {
    e.preventDefault();

    const $form = $(e.target);

    let formData = $form.serialize();

    $(selector.invalidFeedback).hide();
    $(selector.isInvalid).removeClass('is-invalid');
    $(selector.preloader).show();

    setTimeout(function () {
        $.ajax({
            async: true,
            url: '/tag-porucivanje-process-form',
            method: 'POST',
            dataType: 'json',
            data: formData,
            success: function (response) {
                if (response) {
                    $(selector.tagSerialNumber).prop('disabled', true);
                    $(selector.tagVerificationCode).prop('disabled', true);
                    $(selector.phoneNumber).prop('disabled', true);
                    $(selector.captcha).prop('disabled', true);
                    $(selector.signature).val(response.signature);

                    $(document).off('submit', selector.checkoutForm);
                    $form.submit();
                } else {
                    $(selector.preloader).hide();
                    $(selector.errorMessage).show();
                    showFormErrors(response.errors);
                }
            },
            error: function (response) {
                $(selector.preloader).hide();
                $(selector.errorMessage).show();
                const r = $.parseJSON(response.responseText);
                showFormErrors(r.errors);
            }
        });
    }, 750);
}

const reloadCaptcha = (e) => {
    e.preventDefault();

    $.ajax({
        type: 'GET',
        url: '/reload-captcha',
        success: function (data) {
            $(selector.captchaHolder).html(data.captcha);
        }
    });
}

const addVehicleInput = function (e) {
    e.preventDefault();

    let tpl = $(selector.tpl.addVehicleInput).html();
    let uuid = helper.uuid();
    const countVehicles = $(selector.registrationInput).length;

    if (countVehicles === 5) {
        return;
    }

    tpl = tpl.replaceAll(':uuid', uuid);

    $(tpl).insertAfter($(selector.addInputVehicleContainer).last());

    recalculateTotal();
}

const removeVehicleInput = function (e) {
    e.preventDefault();
    $(e.target).closest(selector.addInputVehicleContainer).remove();
    recalculateTotal();
}

const recalculateTotal = function () {
    const countVehicles = $(selector.registrationInput).length;
    const deliveryMethod = $(selector.deliveryMethodChecked).attr('id');
    const postCost = (deliveryMethod === 'dm_post') ? 0 : 0;
    const total = countVehicles * 2022 + postCost;

    $(selector.totalAmount).html(helper.numberWithCommas(total));
    $(selector.amount).val(total);
    $(selector.btn.addVehicle).prop('disabled', countVehicles >= 5);
}

const toggleDeliveryMethod = function (e) {
    e.preventDefault();

    let deliveryMethod = $(e.target).attr('id');

    if (deliveryMethod === 'dm_personal') {
        $(selector.dmPersonalInfoContainer).show();
        $(selector.dmPostInfoContainer).hide();
        $(selector.dmParcelMachineInfoContainer).hide();
    } else if (deliveryMethod === 'dm_post') {
        $(selector.dmPersonalInfoContainer).hide();
        $(selector.dmPostInfoContainer).show();
        $(selector.dmParcelMachineInfoContainer).hide();
    } else if (deliveryMethod === 'dm_parcel_machine') {
        $(selector.dmPersonalInfoContainer).hide();
        $(selector.dmPostInfoContainer).hide();
        $(selector.dmParcelMachineInfoContainer).show();
    } else {
        console.error('Undefined customer type');
    }

    recalculateTotal();
}

export {submitForm, reloadCaptcha, addVehicleInput, removeVehicleInput, toggleDeliveryMethod};